<mat-card appearance="outlined">
    <mat-card-title [innerText]="'MAIN_APP_ADRESSES.addressNotizen' | translate"></mat-card-title>
    <mat-card-content [formGroup]="formGroupAdrNotiz" class="address-note-form-content">
    <span class="row" [ngStyle]="{display: !adrNoteIsRichText ? 'block' : 'none'}">
      <mat-form-field>
        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="4" [formControlName]="fldAdrNotizenKey" [id]="fldAdrNotizenKey"></textarea>
      </mat-form-field>
    </span>
    <div [ngStyle]="{display: adrNoteIsRichText ? 'block' : 'none'}" >
        <ejs-richtexteditor #richTxtEditor1 [toolbarSettings]="tools" height="100%" [value]="adrNoteValue">
        </ejs-richtexteditor>
    </div>
    </mat-card-content>

    <mat-dialog-actions>
        <button (click)="save()" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
        <button mat-stroked-button class="cancel" (click)="dialogRef.close(undefined)" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
    </mat-dialog-actions>
</mat-card>
